import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

export default function VolatilityNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #b45309',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#d97706' }}>
        ⚡ Volatility
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <div style={{ display: 'flex', gap: 6 }}>
        <select
          value={data.measure || 'atr'}
          onChange={(e) => onChange('measure', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="atr">ATR</option>
          <option value="bb_width">Bollinger Width</option>
          <option value="historical_vol">Historical Vol</option>
        </select>
        <input
          type="number"
          min={2}
          value={data.period ?? 14}
          onChange={(e) => onChange('period', Math.max(2, parseInt(e.target.value, 10) || 14))}
          style={{ width: 74, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        />
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#b45309' }} />
    </div>
  );
}
